import { ApiClient, OnlineMenu, OnlineMenuItem } from "@dining/api-client";
import dayjs from "dayjs";
import { LoaderFunctionArgs, redirect } from "react-router-dom";

export type MenuItemDetailsLoaderData =
  | Response
  | {
      menuItem: OnlineMenuItem;
    };

export const menuItemDetailsLoader =
  (client: ApiClient, selectedDate: dayjs.Dayjs) =>
  async ({ params }: LoaderFunctionArgs): Promise<MenuItemDetailsLoaderData> => {
    const { cafeId, stationId, menuItemId } = params;
    const menus = await client.getStationFullMenusForDayOfWeek(
      cafeId!,
      stationId!,
      dayjs(selectedDate).get("day"),
    );
    let menuItem: OnlineMenuItem | undefined;
    menus.items?.forEach((menu: OnlineMenu) => {
      menu?.items?.forEach((item: OnlineMenuItem) => {
        if (item.id === menuItemId) {
          menuItem = item;
        }
      });
    });
    return menuItem ? { menuItem } : redirect("/cafe/" + cafeId + "/station/" + stationId);
  };
